import { atom } from 'recoil';

export const isNewClientModalOpenAtom = atom<boolean>({
  key: 'isNewClientModalOpenState',
  default: false,
});
